import { isAnalyticsWorkerActive, setIsAnalyticsWorkerActive } from "owa-analytics-core";
import type { AnalyticsOptions, CoreAnalyticsOptions } from "owa-analytics-types";
import type { StartupAnalyticsInfo } from "owa-config-types";
import { trace } from "owa-trace";
import { initializeOnMainThread } from "./initializeOnMainThread";
import { getCachedAnalyticsOptions } from "./cacheSettings";

export async function initializeAnalytics(analyticsOptions: AnalyticsOptions, startupAnalyticsInfo: StartupAnalyticsInfo): Promise<CoreAnalyticsOptions> {
    const useAnalyticsWorker = !!analyticsOptions.useAnalyticsWorker;
    
    setIsAnalyticsWorkerActive(useAnalyticsWorker);
    
    trace.info(` Initializing Analytics. Will use worker: ${isAnalyticsWorkerActive()}`, "analytics");
    
    if (getCachedAnalyticsOptions()) {
        trace.info(" Analytics already initialized. Updating instead.", "analytics");
        analyticsOptions.reInitializeAnalytics = true;
    }
    
    const coreAnalyticsOptions = await initializeOnMainThread(analyticsOptions, useAnalyticsWorker /* Send the events to the web worker */, startupAnalyticsInfo);
    
    analyticsOptions = coreAnalyticsOptions;
    
    return coreAnalyticsOptions;
}
